import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";

// Import all landing page sections
import Header from "./components/landing/Header";
import HeroSection from "./components/landing/HeroSection";
import ProblemSection from "./components/landing/ProblemSection";
import SolutionSection from "./components/landing/SolutionSection";
import HowItWorksSection from "./components/landing/HowItWorksSection";
import RevolutionarySection from "./components/landing/RevolutionarySection";
import DualAudienceSection from "./components/landing/DualAudienceSection";
import UseCaseSection from "./components/landing/UseCaseSection";
import ProductSection from "./components/landing/ProductSection";
import AdvantagesSection from "./components/landing/AdvantagesSection";
import VisionSection from "./components/landing/VisionSection";
import PricingSection from "./components/landing/PricingSection";
import FAQSection from "./components/landing/FAQSection";
import CTASection from "./components/landing/CTASection";
import Footer from "./components/landing/Footer";

// Import legal pages
import PrivacyPolicy from "./components/legal/PrivacyPolicy";
import TermsOfService from "./components/legal/TermsOfService";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white" data-testid="landing-page">
      <Header />
      <main>
        <HeroSection />
        <ProblemSection />
        <SolutionSection />
        <HowItWorksSection />
        <RevolutionarySection />
        <DualAudienceSection />
        <UseCaseSection />
        <ProductSection />
        <AdvantagesSection />
        <VisionSection />
        <PricingSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
